import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Email icon
 * @author Praveen Punniyamoorthi
 */
const Email = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M3.5,4 L20.5,4 C21.8807119,4 23,5.11928813 23,6.5 L23,18.5 C23,19.8807119
      21.8807119,21 20.5,21 L3.5,21 C2.11928813,21 1,19.8807119 1,18.5 L1,6.5
      C1,5.11928813 2.11928813,4 3.5,4 Z M21,6.51937515 L21,6.5 C21,6.22385763
      20.7761424,6 20.5,6 L3.5,6 C3.22385763,6 3,6.22385763 3,6.5 L3,6.51937515
      L10.1259149,12.220107 C11.2215708,13.0966318 12.7784292,13.0966318 13.8740851,12.220107
      L21,6.51937515 Z M21,9.08062485 L15.1234752,13.7818447 C13.297382,15.2427193 10.702618,15.2427193
      8.87652476,13.7818447 L3,9.08062485 L3,18.5 C3,18.7761424 3.22385763,19 3.5,19 L20.5,19
      C20.7761424,19 21,18.7761424 21,18.5 L21,9.08062485 Z"
    />
  </SvgIcon>
);

export default Email;
